// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addressDrawerContainerStyles } from "@tps/Overrides/Widgets/Header/AddressDrawerContainer";
import { css } from "styled-components";

addressDrawerContainerStyles.drawerContainer = {
    gap: 20,
    css: css`
        margin-bottom: 30px;
    `,
};
addressDrawerContainerStyles.punchOutAddressGridItem = {
    width: 12,
};
addressDrawerContainerStyles.fulfillmentMethodGridItem = {
    width: 6,
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 30px;
    `,
};
addressDrawerContainerStyles.addressesGridItem = {
    width: 6,
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 30px;
    `,
};
